import React from 'react'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import MainBannerWrapper from './MainBannerWrapper'
import MainBannerContent from './MainBannerContent'

const StyledMainBanner = styled.section`
  background: linear-gradient(${theme('colors.primary')}, ${theme('colors.secondary')});
  color: ${theme('colors.white')};
`

function MainBanner({ children }) {
  return (
    <StyledMainBanner role='banner'>
      <MainBannerWrapper as='article'>
        <MainBannerContent>
          {children}
        </MainBannerContent>
      </MainBannerWrapper>
    </StyledMainBanner>
  )
}

export default MainBanner
